export default __webpack_public_path__ + "static/media/mobx.d89e57ce.svg";